import LandingHeader from '../../components/layout/LandingHeader'
import LandingFooter from '../../components/layout/LandingFooter'

export default function Terms() {
  return (
    <div className="min-h-screen flex flex-col">
      <LandingHeader />

      <div className="flex-grow bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Terms & Conditions</h1>
            <p className="text-gray-600 mb-8">Last Updated: {new Date().toLocaleDateString()}</p>

            <div className="prose max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
                <p className="text-gray-700 mb-4">
                  By accessing and using BarterSheet ("the Platform"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Use License</h2>
                <p className="text-gray-700 mb-4">
                  Permission is granted to temporarily access the materials (information or software) on BarterSheet for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                  <li>Modify or copy the materials</li>
                  <li>Use the materials for any commercial purpose or for any public display (commercial or non-commercial)</li>
                  <li>Attempt to decompile or reverse engineer any software contained on BarterSheet</li>
                  <li>Remove any copyright or other proprietary notations from the materials</li>
                  <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. BarterCoin System</h2>
                <p className="text-gray-700 mb-4">
                  BarterCoins are virtual currency units used within the Platform to facilitate service exchanges. By using BarterCoins, you acknowledge that:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                  <li>BarterCoins have no monetary value outside of the Platform</li>
                  <li>BarterCoins cannot be exchanged for real currency</li>
                  <li>We reserve the right to modify BarterCoin values or policies with notice</li>
                  <li>BarterCoins held in escrow are subject to successful completion of agreed services</li>
                  <li>Unused BarterCoins remain in your account even after subscription cancellation</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. User Responsibilities</h2>
                <p className="text-gray-700 mb-4">
                  As a user of BarterSheet, you agree to:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                  <li>Provide accurate and truthful information in your profile and barter listings</li>
                  <li>Honor all agreements made through the Platform</li>
                  <li>Deliver services as described in your barter offers</li>
                  <li>Communicate professionally and respectfully with other users</li>
                  <li>Not engage in fraudulent or deceptive practices</li>
                  <li>Maintain the confidentiality of your account credentials</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Escrow and Dispute Resolution</h2>
                <p className="text-gray-700 mb-4">
                  BarterSheet provides an escrow system to protect both parties in a transaction. When a barter is accepted:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                  <li>BarterCoins are held in escrow until services are completed</li>
                  <li>Both parties must confirm completion before BarterCoins are released</li>
                  <li>In case of disputes, BarterSheet may mediate to reach a fair resolution</li>
                  <li>BarterSheet reserves the right to make final decisions in unresolved disputes</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Prohibited Activities</h2>
                <p className="text-gray-700 mb-4">
                  You may not use BarterSheet to:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                  <li>Engage in illegal activities or services</li>
                  <li>Harass, abuse, or harm other users</li>
                  <li>Post false, misleading, or fraudulent content</li>
                  <li>Attempt to manipulate the BarterCoin system</li>
                  <li>Create multiple accounts to circumvent platform limitations</li>
                  <li>Scrape, data mine, or use automated systems to access the Platform</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Subscription and Billing</h2>
                <p className="text-gray-700 mb-4">
                  Subscription fees are billed monthly or annually as selected. You agree that:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                  <li>Fees are non-refundable except as required by law</li>
                  <li>You authorize automatic billing for recurring subscriptions</li>
                  <li>We may change pricing with 30 days notice</li>
                  <li>You can cancel your subscription at any time</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Intellectual Property</h2>
                <p className="text-gray-700 mb-4">
                  The Platform and its original content, features, and functionality are owned by BarterSheet and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Termination</h2>
                <p className="text-gray-700 mb-4">
                  We may terminate or suspend your account and access to the Platform immediately, without prior notice or liability, for any reason, including breach of these Terms. Upon termination, your right to use the Platform will cease immediately.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Limitation of Liability</h2>
                <p className="text-gray-700 mb-4">
                  BarterSheet acts as a platform to facilitate connections between users. We are not responsible for the quality, safety, or legality of services exchanged through the Platform. Users engage in barters at their own risk.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Changes to Terms</h2>
                <p className="text-gray-700 mb-4">
                  We reserve the right to modify these terms at any time. We will notify users of any changes by posting the new Terms on this page and updating the "Last Updated" date. Your continued use of the Platform after such modifications constitutes acceptance of the updated Terms.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Contact Information</h2>
                <p className="text-gray-700 mb-4">
                  If you have any questions about these Terms, please contact us through our contact page or email us at support@bartersheet.com.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>

      <LandingFooter />
    </div>
  )
}
